

// プログレス登録
var CaracolLoadProgress = require('../caracol2/util/progress.js');
var progress = new CaracolLoadProgress({
    // urls: window.app.progress_base_urls,
    onProgress: onProgress, onComplete:onComplete, onError:onError
});
// 読み込んだ外部ファイルで指示されている先読み指定ファイルを取得
progress.add_urls( window.app.progress_page_urls );

// プログレス開始
progress.start();
// start_inView();

/**********************
* エラー
*/
function onError( url, jqXHR, textStatus, errorThrown ){
    console.log("[load error]", url);
}

/**********************
* プログレス：読み込み中
*/
function onProgress( total, count, percent, url ){
    var per = percent * 100;
    $('.js-fadein-progress').css({ width:per+'%' });
}
/**********************
* プログレス：読み込み完了
*/
function onComplete( total, count ){
    setTimeout( function(){
        $('.js-fadein-progress').css({ width:'100%' });
        $('.c-fadein').addClass('c-fadein_start');
    }, 200 );

    // フェードイン終わったら消す
    $('.c-fadein')
    .on("oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend",
        function( e ){
            // 透明度以外のアニメ終了は無視
            if( e.originalEvent.propertyName !== 'opacity' ) return;

            $('.c-fadein').hide();

            // スクロールインエフェクト
            start_inView();

            // フェードイン完了イベント発火
            $(window).trigger('onFadeinComplete');
        }
    );
}
/**********************
* inView 開始
*/
function start_inView(){
    // トップページのビジュアル、アニメスタート
    // $('#page-home .home-bg').attr('data-home-start', 'true');
    // $('#page-home .home__center-sp').attr('data-home-start', 'true');

    var CaracolScrollInView = require('../caracol2/effect/scroll_in_view.js');
    var inView = new CaracolScrollInView( '.p-iv', {
        class:{
            in:'p-iv_in'
        }
    } );

    // inViewはホームページだけ遅延させる
    // var delay = $('#page-home').length ? 1300 : 0;

    // setTimeout( function(){
    //     // スマホヘッダの表示
    //     $('#page-home .c-sp-header_home').attr('data-home-start', 'true');
        inView.start();
    // }, delay );

    // ちらつき対策のために遅延させる
    if( $('#page-character').length ){
        // setTimeout( function(){
            // require('../page/page_chara.js');
        // }, 1000);
    }
}



